import { z } from 'zod';

const optionalText = z.string().optional();

/** Contact-edit schema: allow incomplete parent records to update address. */
export const parentSchema = z.object({
  firstName: z.string().min(2, 'Name must be at least 2 characters'),
  lastName: z.string().min(2, 'Last name must be at least 2 characters'),
  email: z.string().email('Invalid email address'),
  primaryPhone: z
    .string()
    .refine(
      (value) => !value || value.replace(/\D/g, '').length >= 10,
      'Phone number must be at least 10 digits',
    ),
  familyName: z.string().optional(),
  relation: z
    .string()
    .refine(
      (value) => !value || value.trim().length >= 2,
      'Relation must be at least 2 characters',
    ),
  address: z.object({
    street: optionalText,
    city: optionalText,
    state: optionalText,
    country: optionalText,
    zip: optionalText,
  }),
});

export type ParentFormValues = z.infer<typeof parentSchema>;
